import { useState } from 'react';

/**
 * Scale/rating input for Menti participants.
 * Row of numbered buttons with optional end labels.
 *
 * @param {Object} props
 * @param {Object} props.slide - Slide data with config.max, config.minLabel, config.maxLabel
 * @param {function} props.onSubmit - Called with the selected number
 * @param {boolean} props.loading
 */
export default function ScaleInput({ slide, onSubmit, loading }) {
  const [selected, setSelected] = useState(null);
  const max = slide.config?.max || 5;
  const minLabel = slide.config?.minLabel || '';
  const maxLabel = slide.config?.maxLabel || '';

  const numbers = Array.from({ length: max }, (_, i) => i + 1);

  const handleSubmit = () => {
    if (selected === null || loading) return;
    onSubmit(selected);
  };

  return (
    <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-6 border border-white/15">
      <div className="flex flex-col gap-5">
        {/* Labels */}
        {(minLabel || maxLabel) && (
          <div className="flex items-center justify-between px-1">
            <span className="text-white/60 text-sm font-medium">{minLabel}</span>
            <span className="text-white/60 text-sm font-medium">{maxLabel}</span>
          </div>
        )}

        {/* Number buttons */}
        <div className="flex items-center justify-center gap-2 flex-wrap">
          {numbers.map((num) => {
            const isSelected = selected === num;

            return (
              <button
                key={num}
                onClick={() => setSelected(num)}
                disabled={loading}
                className={`
                  w-12 h-12 md:w-14 md:h-14 rounded-full text-lg font-bold
                  flex items-center justify-center
                  transition-all duration-200 shadow-md
                  ${isSelected
                    ? 'bg-blue-400 text-white ring-4 ring-blue-300/50 scale-110'
                    : 'bg-white/20 text-white hover:bg-white/30 hover:scale-105 active:scale-95'
                  }
                `}
              >
                {num}
              </button>
            );
          })}
        </div>

        {/* Submit */}
        <button
          onClick={handleSubmit}
          disabled={selected === null || loading}
          className="w-full h-12 bg-gradient-to-r from-blue-500 to-blue-600 text-white text-lg font-bold rounded-full shadow-lg hover:shadow-xl hover:-translate-y-0.5 hover:brightness-110 active:translate-y-0 transition-all duration-200 disabled:opacity-40 disabled:hover:translate-y-0 disabled:hover:shadow-lg flex items-center justify-center gap-2"
        >
          {loading ? (
            <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
          ) : (
            <>
              <span>Send svar</span>
              <span className="material-symbols-outlined text-xl">send</span>
            </>
          )}
        </button>
      </div>
    </div>
  );
}
